import React from 'react';
import { useTranslation } from 'react-i18next';

const useWebHookStatus = webhook => {
    const { t } = useTranslation();

    let status;
    if (!webhook) status = 'inactive';
    else status = webhook.active ? (webhook.paused_at ? 'paused' : 'active') : 'inactive';

    const values = React.useMemo(() => {
        switch (status) {
            case 'active':
                return { color: 'green', text: t('common.active') };
            case 'paused':
                return { color: 'orange', text: t('common.paused') };
            default:
                return { color: null, text: t('common.inactive') };
        }
    }, [status, t]);

    return { status, ...values };
};

export default useWebHookStatus;
